export default function Rust_Output() {
  return (
    <div>
      <h1>Rust_Output Component</h1>
      <p>This is the Rust_Output page.</p>
    </div>
  );
}
